import React from 'react';
import { requestDeleteCreative, deleteCreativeError, deleteCreativeSuccess } from 'modules/campaigns/actions';
import { removeCreativeItemRow } from 'modules/campaigns/modules/campaigns-reports/actions';
import { isCreativeLibraryEnabled } from 'modules/campaigns/modules/campaigns-reports/config/predicates';
import { INDICATION_TYPES, addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { selectedAccountSelector } from 'selectors';
import { assignCreativesApi, creativesApi, videoCreativesApi } from 'services/api';
import { isVideoCampaign } from 'services/campaignDimension';
import { generateErrorIndication } from 'services/utils';

const indications = {
    error: {
        message: <FormattedMessage id="creative.remove.error" defaultMessage="We were not able to remove the ad" />,
        type: INDICATION_TYPES.ERROR,
        highlight: <FormattedMessage id="error.highlight" defaultMessage="Error!" />,
    },
    success: {
        message: <FormattedMessage id="creative.remove.success" defaultMessage="Ad successfully removed" />,
        type: INDICATION_TYPES.SUCCESS,
        highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
    },
};

export const deleteCreative = (data, context) => async (dispatch, getState) => {
    const { accountName, campaignId, id, adId, dimension, isCreativeLibrary } = data;
    const { accountId: selectedAccountId } = selectedAccountSelector(getState());
    const accountId = accountName || selectedAccountId;
    dispatch(requestDeleteCreative());
    const shouldArchiveAd = isCreativeLibrary && isCreativeLibraryEnabled(context?.selectedAccountConfig);
    const changes = {
        isArchived: true,
    };
    try {
        let creativeItem;
        if (isVideoCampaign(dimension)) {
            creativeItem = await videoCreativesApi.deleteCreative(accountId, campaignId, id);
        } else {
            creativeItem = shouldArchiveAd
                ? (creativeItem = await assignCreativesApi.updateAd(accountId, adId, changes))
                : await creativesApi.deleteCreative(accountId, campaignId, id);
        }

        dispatch(deleteCreativeSuccess(creativeItem));
        dispatch(addIndication(indications.success));
        dispatch(removeCreativeItemRow(id));
    } catch (error) {
        dispatch(deleteCreativeError(error));
        dispatch(addIndication(generateErrorIndication(error, indications.error.message)));
    }
};
